<template>
  <div class="color-second-background s-wrapper">
    <div class="s-container">
      <button type="button" @click="onToggleFilters" class="s-filters-toggle s-filters-toggle-tablet">{{ Translator('front.search.filters') }}</button>
      <form class="std-form s-form" @submit="submitSearch">
        <div class="form-group s-form-group">
          <input aria-describedby="searchinfos" @input="onDebounceSearch" @mouseenter="onFocusSearch" @mouseleave="isTooltipOpen = false" autocomplete="off" type="text" name="query" v-model="query" :placeholder="searchPlaceholder" :title="searchPlaceholder" class="form-control s-form-form-control">
          <div class="s-autocomplete-tooltip-hover" :class="{'is-open': isTooltipOpen}" v-if="tooltipOnHover" v-safe-html="tooltipOnHover"></div>
          <div aria-live="polite" class="sr-only">
            <p v-if="isSearching">{{ Translator('front.search.searching') }}</p>
            <p v-if="!isSearching && query && query.length >= 3">{{ Translator('front.search.results', {results_propose: propositions.length }) }}</p>
          </div>
          <div class="s-autocomplete" v-if="autoCompleteIsShow && propositions && propositions.length > 0" @mouseleave="onLeaveSearch" @mouseenter="onEnterSearch">
            <ul class="s-autocomplete-list">
              <li class="s-autocomplete-element" v-for="propose in propositions" :key="propose.id">
                <a class="s-autocomplete-link" :href="propose.url">
                  <div class="s-autocomplete-media">
                    <div class="s-autocomplete-image">
                      <img v-if="propose.images && propose.images.small" :src="propose.images.small" alt="">
                      <div class="s-autocomplete-image-empty" v-else>
                        <span class="sprite -empty-image">
                          <svg viewBox="0 0 1 1" role="img" aria-hidden="true"><use xlink:href="#empty-image"></use></svg>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="s-autocomplete-content">
                    <p class="s-autocomplete-title">{{ propose.titles && propose.titles.title ? propose.titles.title : propose.title }}</p>
                    <p class="s-autocomplete-text" v-if="propose.titles && propose.titles.subTitle">{{ propose.titles.subTitle }}</p>
                  </div>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <button type="submit" class="button-flat s-form-button">
          <span>{{ Translator('front.search.button') }}</span>
          <i class="ico ico-search"></i>
        </button>
        <div class="s-information">
          <button tooltip="searchinfos" :aria-expanded="(!infosIsShow).toString()" type="button" class="border-accent s-button-infos" @click="onShowInfos">
            <i class="ico ico-infos"></i>
            <span class="hide-access" v-if="!infosIsShow">{{ Translator('front.search.tooltip_btn_open') }}</span>
            <span class="hide-access" v-if="infosIsShow">{{ Translator('front.search.tooltip_btn_close') }}</span>
          </button>
          <div id="searchinfos" :aria-hidden="(!infosIsShow).toString()" class="color-second-border s-tooltip-informations" v-bind:class="{ 'is-open': infosIsShow }">
            <p v-safe-html="tooltipHelpText"></p>
          </div>
        </div>
      </form>
      <div class="s-actions">
        <button type="button" @click="onToggleFilters" class="s-filters-toggle">{{ Translator('front.search.filters') }}</button>
        <h2>
          <button type="button" @click="onToggleHistory" :aria-expanded="(!historyIsShow).toString()" class="s-history-toggle" v-if="historics && historics.length > 0 && hasHistory" v-bind:class="{ 'is-open': historyIsShow }">
            {{ Translator('front.search.history_label') }}
            <i class="ico ico-chevron-right" aria-hidden="true"></i>
          </button>
        </h2>
      </div>
    </div>

    <div class="color-second-background s-history" v-bind:class="{ 'is-open': historyIsShow }" v-if="historics && historics.length > 0 && hasHistory">
      <div class="s-history-wrapper">
        <p class="s-history-title">{{ Translator('front.search.history_label') }}</p>
        <div class="s-history-list">
          <p class="s-history-element" v-for="historic in historics" :key="historic.query">
            <a :href="historic.url" class="button-shadow s-history-button" type="button">
              <div class="s-history-search">
                <p class="s-history-query">{{ historic.params.query }}</p>
                <div class="s-history-facets" v-if="historic.params.f && historic.params.f.length > 0">
                  <p class="color-second-background s-history-facet" v-for="facet in historic.params.f" :key="facet.id">{{ facet.name }}</p>
                </div>
              </div>
              <span class="s-history-time">{{ historic.date | fromNow }}</span>
            </a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import helper from '@/helper';
import moment from 'moment';
import debounce from 'debounce';
import ConfigService from '@/front/services/config';
import SearchService from '@/front/services/search';
import NoticesService from '@/front/services/notices';

export default {
  name: 'Search',
  props: [],
  data: () => ({
    query: helper.getQueryParameter('query'),
    propositions: [],
    historics: SearchService.historic,
    filtersIsShow: false,
    historyIsShow: false,
    isSearching: false,
    autoCompleteIsShow: false,
    infosIsShow: false,
    searchPlaceholder: '',
    tooltipHelpText: '',
    tooltipOnHover: '',
    isTooltipOpen: false,
    hasHistory: !ConfigService.get('isCollectionView')
  }),
  filters: {
    fromNow: function (value) {
      if (!value) return '';
      const date = moment(value);
      return date.fromNow();
    }
  },
  computed: { },
  mounted() {
    this.searchPlaceholder = this.entitiesDecode( window.config.search.placeholder );
    this.tooltipHelpText = this.entitiesDecode( window.config.search.tooltipHelp );
    if(window.config.search.tooltipOnHover) {
      this.tooltipOnHover = this.entitiesDecode( window.config.search.tooltipOnHover );
    }
  },
  created () {
    SearchService.on('update-params', this._onUpdateParams);
    SearchService.on('historic', this._onUpdateHistoric);
    SearchService.on('filters-is-show', this._onToggleFilters);
  },
  beforeDestroy() {
    SearchService.off('historic', this._onUpdateHistoric);
    SearchService.off('filters-is-show', this._onToggleFilters);
  },
  methods: {
    entitiesDecode(text) {
      const el = document.createElement('textarea');
      el.innerHTML = text;
      return el.value;
    },
    onToggleFilters() {
      SearchService.filtersIsShow = !this.filtersIsShow;
    },

    onToggleHistory() {
      this.historyIsShow = !this.historyIsShow;
    },

    onShowInfos() {
      this.infosIsShow = !this.infosIsShow;
    },

    onFocusSearch() {
      this.onEnterSearch();
      this.autoCompleteIsShow = true;
      this.isTooltipOpen = true;
    },

    onEnterSearch() {
      clearTimeout(this._timeoutautocomplete);
    },

    onLeaveSearch() {
      this._timeoutautocomplete = setTimeout(() => {
        this.autoCompleteIsShow = false;
      }, 600);
    },

    onMouseEnterInfos() {
      clearTimeout(this._timeoutinfos);
    },

    onMouseLeaveInfos() {
      this._timeoutinfos = setTimeout(() => {
        this.infosIsShow = false;
      }, 800);
    },

    onMouseEnterHistory() {
      clearTimeout(this._timeoutclose);
    },

    onMouseLeaveHistory() {
      this._timeoutclose = setTimeout(() => {
        this.historyIsShow = false;
      }, 800);
    },

    onDebounceSearch: debounce( function() {
      this.propositions = [];
      if(this.query.length <= 2) return;
      this.isSearching = true;
      NoticesService.getAutocomplete(this.query).then( res => {
        this.propositions = res.data['hydra:member'];
        this.autoCompleteIsShow = true;
        this.isSearching = false;
        this.onEnterSearch();
      })
    }, 300),

    submitSearch(pEvt) {
      if(pEvt) pEvt.preventDefault();
      this.historyIsShow = false;
      SearchService.page_silence = 1;
      SearchService.query = this.query;
    },

    _onUpdateParams() {
      this.query = SearchService.query;
    },

    _onUpdateHistoric() {
      this.historics = SearchService.historic;
    },

    _onToggleFilters(open) {
      this.filtersIsShow = open;
    },

    Translator(key, datas = null) {
      return window.Translator.trans(key, datas);
    }
  }
}
</script>

<style scoped lang="scss">
  .viewer-element {
    .s-wrapper {
      position: relative;
    }
    .s-actions {
      display: flex;
      align-self: center;
      @include mobile {
        width: 100%;
        justify-content: space-between;
        margin-top: rem(30);
      }
      @include tablet {
        margin-left: rem(30);
      }
    }
    .s-container {
      @include wrapper;
      position: relative;
      padding: rem(30) 0;
      display: flex;
      justify-content: space-between;
      @include mobile {
        flex-wrap: wrap;
      }
    }
    .s-filters-toggle {
      padding: rem(5) rem(10);
      @include tablet {
        display: none;
      }
      &.s-filters-toggle-tablet {
        display: none;
        margin-right: rem(15);
        @include tablet-only {
          display: block;
        }
      }
    }
    .s-autocomplete {
      border-radius: rem(4) 0 rem(4) rem(4);
      background-color: $white;
      box-shadow: 0 rem(5) rem(5) rgba($black, .1);
    }
    .s-autocomplete-tooltip-hover {
      position: absolute;
      bottom: rem(-10);
      transform: translateY(100%);
      background: white;
      padding: rem(10) rem(25);
      border-radius: rem(5);
      box-shadow: 0 0 rem(5) 0 rgba($black, .2);
      max-width: rem(300);
      font-size: rem(12);
      opacity: 0;
      transition: opacity .2s;
      pointer-events: none;
      background-color: $white;
      z-index: 10;
      &.is-open {
        opacity: 1;
      }
    }
    .s-history-toggle {
      padding: rem(5) rem(10);
      white-space: nowrap;
      .ico {
        display: inline-block;
        margin-left: rem(10);
        transform: rotate(-90deg);
        transition: transform .2s;
      }
      &.is-open {
        .ico {
          transform: rotate(90deg);
        }
      }
    }

    .s-history {
      display: none;
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      transform: translateY(100%);
      z-index: 4;
      &.is-open {
        display: block;
      }
      .s-history-wrapper {
        @include wrapper;
        padding-top: rem(40);
        padding-bottom: rem(40);
        border-top: rem(2) solid $grey;
      }
      .s-history-title {
        margin-bottom: rem(15);
      }
      .s-history-query {
        margin-right: rem(5);
      }
      .s-history-search {
        display: flex;
      }
      .s-history-facets {
        display: flex;
        flex-wrap: wrap;
        gap: rem(3);
      }
      .s-history-facet {
        font-size: .7em;
        padding: rem(2) rem(5);
        border-radius: rem(20);
        display: inline-block;
        font-weight: normal;
        white-space: nowrap;
        max-width: rem(150);
        text-overflow: ellipsis;
        overflow: hidden;
        line-height: 1;
        vertical-align: middle;
      }
      .s-history-list {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        margin-left: rem(-5);
        margin-right: rem(-5);
        @include tablet {
          margin-left: rem(-10);
          margin-right: rem(-10);
        }
      }
      .s-history-element {
        margin-bottom: rem(10);
        width: 100%;
        padding-left: rem(5);
        padding-right: rem(5);
        @include phablet {
          width: percentage(1/2);
        }
        @include tablet {
          padding-left: rem(10);
          padding-right: rem(10);
          width: percentage(1/3);
        }
        @include desktop-xl {
          width: percentage(1/3);
        }
      }
      .s-history-button {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .s-history-query {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        font-weight: bold;
      }
      .s-history-time {
        font-size: .8em;
        font-weight: normal;
      }
    }
    .s-information {
      position: relative;
      margin-left: rem(15);
    }
    .s-button-infos {
      @include resetBtn;
      text-align: center;
      width: rem(25);
      height: rem(25);
      line-height: rem(25);
      border-width: rem(1);
      border-style: solid;
      border-radius: 100%;
      display: block;
      flex-shrink: 0;
    }
    .s-tooltip-informations {
      z-index: 6;
      position: absolute;
      border-style: solid;
      border-width: rem(3);
      background-color: $white;
      width: rem(250);
      padding: rem(10) rem(15);
      display: none;
      font-size: .8em;
      @include mobile {
        left: rem(-10);
        top: rem(-10);
        transform: translateX(-100%);
      }
      @include tablet {
        transform: translateY(100%) translateX(-50%);
        left: 50%;
        bottom: rem(-10);
      }
      &.is-open {
        display: block;
      }
    }
  }
</style>